import styles from '../ProductQuiz.module.scss';
import React, { useEffect } from 'react';
import { Button, Flex, Text, Grid } from '@mantine/core';
import { useProductQuiz } from '../ProductQuizContext';
import { QuestionTitle } from './QuestionTitle';
import { quizQuestionPage } from '../../../lib/analytics/events';
import { useTranslation } from 'react-i18next';

const SIZES = [
  { size: 'Extra Small', subtitle: 'Under 10 lbs' },
  { size: 'Small', subtitle: '10-25 lbs' },
  { size: 'Medium', subtitle: '26-40 lbs' },
  { size: 'Large', subtitle: '40+ lbs' },
];

export const QuestionSize: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    quizQuestionPage.quizPetSizePageEntered();
  }, []);

  const { quizAnswers, setQuizAnswers, nextQuestion } = useProductQuiz();

  const items = SIZES.map(({ size, subtitle }) => (
    <Grid.Col span={6} key={size}>
      <Button
        unstyled
        data-active={size === quizAnswers.selectedSize || undefined}
        className={styles.quizButton}
        onClick={() => {
          quizQuestionPage.quizPetSizeNext(size);
          setQuizAnswers({ ...quizAnswers, selectedSize: size });
          nextQuestion();
        }}
        sx={{
          width: '100%',
          height: '100px',
          borderRadius: 16,
        }}
      >
        <Flex direction="column" align="center" justify="center">
          <Text
            size={24}
            weight={600}
            lh="120%"
            sx={(theme) => ({
              color: size === quizAnswers.selectedSize ? theme.colors['fi-yellow'] : 'white',
              letterSpacing: '-0.48px',
            })}
          >
            {size}
          </Text>
          <Text
            size={16}
            weight={400}
            sx={(theme) => ({
              color: size === quizAnswers.selectedSize ? theme.colors['fi-yellow'] : 'white',
              fontSize: 16,
              fontWeight: 400,
            })}
          >
            {subtitle}
          </Text>
        </Flex>
      </Button>
    </Grid.Col>
  ));

  return (
    <>
      <QuestionTitle>{t('what_size_best_describes_name', { name: quizAnswers.petName })}</QuestionTitle>
      <Grid w="100%" p="md" gutter={8}>
        {items}
      </Grid>
    </>
  );
};
